import { render } from "./MainQueryResult.vue?vue&type=template&id=595d106a"
import script from "./MainQueryResult.vue?vue&type=script&lang=js"
export * from "./MainQueryResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__